import { Controller } from '@hotwired/stimulus';

/**
 * Si no existe el parámetro en la URL, lo añade. Si
 * ya existía sustituye su valor
 */
/* eslint-disable no-param-reassign */
/* eslint-disable prefer-template */
function replaceUrlParam(url, paramName, paramValue) {
  if (paramValue === null) {
    paramValue = '';
  }
  const pattern = new RegExp('\\b(' + paramName + '=).*?(&|$)');
  if (url.search(pattern) >= 0) {
    return url.replace(pattern, '$1' + paramValue + '$2');
  }
  return url + (url.indexOf('?') > 0 ? '&' : '?') + paramName + '=' + paramValue;
}

/*
 * Traído componente viejo a controlador. Código tal cual
 */
/* global $ */
export default class SelectorAnnoLectivo extends Controller {
  connect() {
    const $this = $(this.element);
    $this.on('click', 'li', function onClick() {
      const nuevo = $(this).data('value');
      const url = $(this).data('current-url');
      window.location = replaceUrlParam(url, 'anno_lectivo_id', nuevo);
    });
  }
}
